import Box from '@mui/material/Box';
import { Helmet } from 'react-helmet';

import { useAiCopilot } from '../../../components/ai-copilot/context/use-ai-copilot';
import { VyLayout } from '../../../components/new-design/layout/VyLayout';
import { withGlobalSearchParams } from '../../../components/utility/GlobalSearchParamsBoundary';
import { withSuspenseBoundary } from '../../../components/utility/SuspenseBoundary';
import { CustomerRevenueReportContent } from './customer-revenue-report-components/CustomerRevenueReportContent';

const CustomerRevenueReportLayout: React.FC = () => {
  const { isOpen, drawerWidth } = useAiCopilot();

  return (
    <Box
      sx={{
        transition: (theme) =>
          theme.transitions.create('margin-right', {
            easing: isOpen
              ? theme.transitions.easing.easeOut
              : theme.transitions.easing.sharp,
            duration: isOpen
              ? theme.transitions.duration.enteringScreen
              : theme.transitions.duration.leavingScreen,
          }),
        marginRight: isOpen ? `${drawerWidth}px` : 0,
      }}
    >
      <VyLayout>
        <CustomerRevenueReportContent />
      </VyLayout>
    </Box>
  );
};

const CustomerRevenueReportPage: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Customer Revenue Report</title>
      </Helmet>
      <CustomerRevenueReportLayout />
    </>
  );
};

const CustomerRevenueReportPageWithSuspenseBoundary = withSuspenseBoundary(
  withGlobalSearchParams(CustomerRevenueReportPage),
);

export { CustomerRevenueReportPageWithSuspenseBoundary as CustomerRevenueReportPage };
